/**
 * The cases constants module houses cases-specific configurations.
 *
 * @module routes.cases.states.constants
 */

angular.module('routes.cases.states.constants', [])
  .config([
    '$provide',
    function ($provide) {
      'use strict';

      // Define.
      var states;

      /**
       * Defines states constants.
       *
       * @attribute STATES
       * @type String
       * @readOnly
       */
      $provide.constant('STATES', states);
    }
  ]);
